// Styles partagés du module CRI — alignés sur la charte dense de l'ERP.
export const inputCls =
  'mt-1.5 h-11 w-full border border-slate-300 bg-slate-50 px-3 font-data text-sm text-slate-900 outline-none transition-colors duration-150 focus:border-slate-900 focus:bg-white';
export const labelCls = 'text-xs font-bold uppercase tracking-[0.1em] text-slate-500';
export const th = 'px-3 py-2 text-left text-[11px] font-bold uppercase tracking-[0.1em] text-slate-500';
export const td = 'px-3 py-2 font-data text-sm text-slate-900';
export const btn =
  'flex h-11 items-center justify-center gap-2 bg-slate-900 px-4 text-sm font-semibold text-white transition-colors duration-150 hover:bg-slate-700 disabled:cursor-not-allowed disabled:opacity-40';
export const btnLight =
  'flex h-9 items-center gap-1.5 border border-slate-300 px-2.5 text-xs font-semibold text-slate-700 transition-colors duration-150 hover:bg-slate-900 hover:text-white';

export const Carte = ({ titre, sous, children, testid, action }) => (
  <section data-testid={testid} className="border border-slate-200 bg-white">
    <header className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-200 px-4 py-2.5">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.1em] text-slate-500">{titre}</p>
        {sous && <p className="mt-0.5 text-[11px] text-slate-500">{sous}</p>}
      </div>
      {action}
    </header>
    <div className="p-4">{children}</div>
  </section>
);
